import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { ROLE_DELETE } from "./gql";

export const useBulkRoleDelete = createBulkMutationHook(ROLE_DELETE);

const useRoleDelete = createDefaultMutationHook(ROLE_DELETE);
export default useRoleDelete;
